export const DsChipDefaultProps = {
    type: 'status'
};
